import * as React from 'react';
import { buildClassString } from '../../StringUtils';
import './style/index.scss';
export const PdfPage = (props) => {
    const { className, children } = props;
    const finalClassName = buildClassString({
        'pdf-page': true,
        [className]: !!className
    });
    return (React.createElement("div", { className: finalClassName },
        React.createElement("div", { className: "pdf-page__inner" }, children)));
};
export default PdfPage;
